import { FormHandles, SubmitHandler } from '@unform/core';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import * as Yup from 'yup';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import Modelo1 from '../../assets/models/Modelo 1.png';
/* import Modelo10 from '../../assets/models/Modelo 10.png';
import Modelo11 from '../../assets/models/Modelo 11.png';
import Modelo12 from '../../assets/models/Modelo 12.png';
import Modelo13 from '../../assets/models/Modelo 13.png';
import Modelo14 from '../../assets/models/Modelo 14.png'; */
import Modelo2 from '../../assets/models/Modelo 2.png';
import Modelo3 from '../../assets/models/Modelo 3.png';
import Modelo4 from '../../assets/models/Modelo 4.png';
import Modelo5 from '../../assets/models/Modelo 5.png';
import Modelo6 from '../../assets/models/Modelo 6.png';
import Modelo7 from '../../assets/models/Modelo 7.png';
import Modelo8 from '../../assets/models/Modelo 8.png';
import Modelo9 from '../../assets/models/Modelo 9.png';
import {
  Button,
  Header,
  Input,
  InputView,
  Loading,
  Modal,
  Select,
  Switch,
} from '../../components';
import InputMask from '../../components/InputMask';
import { useAuth } from '../../hooks/useAuth';
import { PreOSData, usePDFData } from '../../hooks/usePDFData';
import api from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';
import schemaValidation from '../../validation/registerOS';
import { bases, eye as eyeOptions, models } from './data';
import * as S from './styles';

const images = [
  Modelo1,
  Modelo2,
  Modelo3,
  Modelo4,
  Modelo5,
  Modelo6,
  Modelo7,
  Modelo8,
  Modelo9,
];

const initialData = {
  horizontal: 0,
  vertical: 0,
  diagonal: 0,
  po: 0,
  esf_left_eye: 0,
  esf_right_eye: 0,
  cil_left_eye: 0,
  cil_right_eye: 0,
  dnp_left_eye: 0,
  dnp_right_eye: 0,
  eixo_right_eye: 0,
  eixo_left_eye: 0,
  add_left_eye: 0,
  add_right_eye: 0,
  height_right_eye: 0,
  height_left_eye: 0,
};

interface FormData {
  os_number: string;
  customer_name: string;
  customer_contact: string;
  customer_certified_id: number;
  ophthalmologist: string;
  salesman: string;
  salesman_cpf?: string;
  technical_assistance: number;
  material_id: number;
  manufacturer_id: number;
  product_type_id?: number;
  product_id: number;
  esf_right_eye: number;
  cil_right_eye: number;
  eixo_right_eye: number;
  add_right_eye: number;
  dnp_right_eye: number;
  esf_left_eye: number;
  cil_left_eye: number;
  eixo_left_eye: number;
  add_left_eye: number;
  dnp_left_eye: number;
  model: string;
  frame: string;
  reference: string;
  horizontal: number;
  vertical: number;
  po: number;
  diagonal: number;
  mounting: number;
  coloring: number;
  coloring_type: string;
  antireflection: number;
  antireflection_type: string;
  observations: string;
  right_base: number;
  right_base_quantity: number;
  left_base: number;
  left_base_quantity: number;
}

interface SalesmanFormData {
  salesman_cpf: string;
  salesman_name: string;
}

interface CertifiedClient extends Partial<SelectModel> {
  id: number;
  name: string;
  fantasy_name: string;
}

interface Manufacturer extends Partial<SelectModel> {
  id: number;
  name: string;
  own_manufacture: number;
}

interface Frame extends Partial<SelectModel> {
  id: number;
  name: string;
}

interface Material extends Partial<SelectModel> {
  id: number;
  name: string;
}

interface Product extends Partial<SelectModel> {
  id: number;
  description: string;
}

interface SelectModel {
  value: number | string;
  label: string;
}

interface ProductType extends Partial<SelectModel> {
  id: number;
  name: string;
  is_add: number;
}

interface Service extends Partial<SelectModel> {
  id: number;
  description: string;
}

interface Salesman {
  id: number;
  cpf: string;
  name: string;
  user: string;
}

let debounceTimer: ReturnType<typeof setTimeout>;

const DeprecationWarning = styled.div`
  background-color: #ff4444;
  color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 10px;

  h2 {
    margin: 0 0 20px 0;
    font-size: 28px;
    font-weight: bold;
  }

  p {
    font-size: 18px;
    margin: 15px 0;
    line-height: 1.8;
  }

  .date {
    font-size: 42px;
    font-weight: bold;
    margin: 30px 0;
    letter-spacing: 3px;
  }

  .intro {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

const DeprecationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const BlockedSystemBanner = styled.div`
  background-color: #dc3545;
  color: white;
  padding: 10px 10px;
  margin: 10px 0;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const RegisterOS = () => {
  const history = useHistory();
  const { setPdfData } = usePDFData();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [coloringActive, setColoringActive] = useState(false);
  const [mounting, setMounting] = useState(false);
  const [antiscratch, setAntiscratch] = useState(false);
  const [antireflectionActive, setAntireflectionActive] = useState(false);
  const [technicalAssistanceActive, setTechnicalAssistanceActive] = useState(
    false,
  );
  const formRef = useRef<FormHandles>(null);
  const salesmanFormRef = useRef<FormHandles>(null);
  const [certifiedClients, setCertifiedClients] = useState<CertifiedClient[]>(
    [],
  );
  const [salesman, setSalesman] = useState<Salesman>({} as Salesman);
  const [productTypes, setProductTypes] = useState<ProductType[]>([]);
  const [manufacturers, setManufacturers] = useState<Manufacturer[]>([]);
  const [frames, setFrames] = useState<Frame[]>([]);
  const [materials, setMaterials] = useState<Material[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [services, setServices] = useState<Service[]>([]);
  const [servicesColoring, setServicesColoring] = useState<Service[]>([]);
  const [selectedImageModel, setSelectedImageModel] = useState(-1);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [modalImagesGridIsOpen, setModalImagesGridIsOpen] = useState(false);
  const [isDisabledToConfirmData, setIsDisabledToConfirmData] = useState(false);
  const [isMeasuresDisabled, setIsMeasuresDisabled] = useState(false);
  const [isEixoRightEyeDisabled, setIsEixoRightEyeDisabled] = useState(true);
  const [isEixoLeftEyeDisabled, setIsEixoLeftEyeDisabled] = useState(true);
  const [isAdditionalDisabled, setIsAdditionalDisabled] = useState(true);
  const [selectedEye, setSelectedEye] = useState('both');
  const [isOSDuplicated, setIsOSDuplicated] = useState(false);
  const [isPrismaEnabledToPrint, setIsPrismaEnabledToPrint] = useState(false);
  const [hasOwnManufacture, setHasOwnManufacture] = useState(true);
  const [modalToConfirmDataIsOpen, setModalToConfirmDataIsOpen] = useState(
    false,
  );
  const [loadingServicesColoring, setLoadingServicesColoring] = useState(false);
  const [
    isSalesmanRegisterModalOpen,
    setIsSalesmanRegisterModalOpen,
  ] = useState(false);

  const [productId, setProductId] = useState<number>(-1);
  const [warning] = useState<string>(
    'Atenção: Os modelos de 1 a 9 foram atualizados.',
  );

  const [showDeprecationModal, setShowDeprecationModal] = useState(false);
  const [isSystemBlocked, setIsSystemBlocked] = useState(false);

  useEffect(() => {
    const currentDate = new Date();
    const blockDate = new Date('2026-01-31T00:00:00'); // 31/01/2026 às 23:59:59

    // Verifica se o sistema está bloqueado
    if (currentDate >= blockDate) {
      setIsSystemBlocked(true);
      toast.error(
        'Sistema bloqueado para novos cadastros a partir de 31/01/2026. Consultas continuam disponíveis.',
        { autoClose: false },
      );
    } else {
      // Mostra o aviso se ainda não passou a data
      const lastShown = localStorage.getItem('deprecation_warning_shown');
      const today = new Date().toDateString();

      if (lastShown !== today) {
        setShowDeprecationModal(true);
        localStorage.setItem('deprecation_warning_shown', today);
      }
    }
  }, []);

  useEffect(() => {
    async function loadSelects() {
      const certifiedClientsResponse = await api.get('certified-clients');
      const productTypesResponse = await api.get('product-types');
      const manufacturersResponse = await api.get('manufacturers');
      const materialsResponse = await api.get('materials');
      const framesResponse = await api.get('frames');

      setMaterials(
        materialsResponse.data.data.map((material: Material) => ({
          label: material.name,
          value: material.id,
        })),
      );
      setManufacturers(
        manufacturersResponse.data.data.map((manufacturer: Manufacturer) => ({
          label: manufacturer.name,
          value: manufacturer.id,
          own_manufacture: manufacturer.own_manufacture,
        })),
      );

      setFrames(
        framesResponse.data.data.map((frame: Frame) => ({
          label: frame.name,
          value: frame.name,
        })),
      );

      setProductTypes(
        productTypesResponse.data.data.map((product: ProductType) => ({
          ...product,
          label: product.name,
          value: product.id,
        })),
      );

      const certifiedClientsFormatted = certifiedClientsResponse.data.data.map(
        (client: CertifiedClient) => ({
          ...client,
          label: client.fantasy_name,
          value: client.id,
        }),
      );

      setCertifiedClients(certifiedClientsFormatted);

      if (certifiedClientsFormatted.length === 1) {
        formRef.current?.setFieldValue(
          'customer_certified_id',
          certifiedClientsFormatted[0].value,
        );
      }
    }

    loadSelects();
  }, []);

  const loadProducts = useCallback(() => {
    clearTimeout(debounceTimer);
    const type = formRef.current?.getFieldValue('product_type_id');
    const material = formRef.current?.getFieldValue('material_id');
    const manufacturer = formRef.current?.getFieldValue('manufacturer_id');

    if (type && material && manufacturer) {
      setLoadingProducts(true);
      debounceTimer = setTimeout(() => {
        api
          .get('products', {
            params: {
              type,
              material,
              manufacturer,
            },
          })
          .then(response =>
            setProducts(
              response.data.data.map((product: Product) => ({
                label: product.description,
                value: product.id,
              })),
            ),
          )
          .then(() => setLoadingProducts(false));
      }, 1500);
    }
  }, []);

  const loadServicesColoring = useCallback(() => {
    clearTimeout(debounceTimer);
    setLoadingServicesColoring(true);
    const coloring = 1;
    const antireflection = 0;

    debounceTimer = setTimeout(() => {
      api
        .get('services', {
          params: {
            antireflection,
            coloring,
          },
        })
        .then(response =>
          setServicesColoring(
            response.data.data.map((obj: Service) => ({
              label: obj.description,
              value: obj.description,
            })),
          ),
        )
        .then(() => setLoadingServicesColoring(false));
    }, 1500);
  }, []);

  const handleColoringState = () => {
    setColoringActive(!coloringActive);
  };

  const toggleOwnManufactureServices = useCallback(() => {
    const manufacturerId = formRef.current?.getFieldValue('manufacturer_id');

    const manufacturer = manufacturers.find(
      item => item.value === manufacturerId,
    );

    if (Number(manufacturer?.own_manufacture) === 1) {
      setHasOwnManufacture(true);
      return;
    }

    // setHasOwnManufacture(false);
    setHasOwnManufacture(true);
  }, [manufacturers]);

  function handleSelectedIdProduct() {
    const prod = formRef.current?.getFieldValue('product_id');
    setProductId(prod);
    // console.log(prod);
    // console.log(productId);
  }

  const handleAntirreflection = async () => {
    setAntireflectionActive(!antireflectionActive);
    /* const manufacturerId = formRef.current?.getFieldValue('manufacturer_id');

    if (!manufacturerId) return;

     const manufacturer = manufacturers.find(
      item => item.value === manufacturerId,
    );

     if (Number(manufacturer?.own_manufacture) === 0) {
      // setHasOwnManufacture(false);
      setHasOwnManufacture(true);
      return;
    } */

    setHasOwnManufacture(true);

    // const servicesResponse = await api.get('services');
    // Marcos
    const coloring = 0;
    const antireflection = 1;
    const idProduct = productId;
    const servicesResponse = await api.get('services', {
      params: {
        antireflection,
        coloring,
        idProduct,
      },
    });

    // console.log(antireflection, coloring, idProduct);

    setServices(
      servicesResponse.data.data.map((service: Service) => ({
        label: service.description,
        value: service.description,
      })),
    );
  };

  const handleTechnicalAssistance = () => {
    setTechnicalAssistanceActive(!technicalAssistanceActive);
  };

  const toggleAdditionalFieldStatus = () => {
    const productTypeId = formRef.current?.getFieldValue('product_type_id');
    const productType = productTypes.find(type => type.value === productTypeId);

    if (Number(productType?.is_add) === 1) {
      setIsAdditionalDisabled(false);
      return;
    }
    formRef.current?.setFieldValue('add_right_eye', 0);
    formRef.current?.setFieldValue('add_left_eye', 0);
    setIsAdditionalDisabled(true);
  };

  const handleEixoStatusField = (eye: 'right' | 'left') => {
    const cilValue = formRef.current?.getFieldValue(`cil_${eye}_eye`);

    if (cilValue < 0) {
      switch (eye) {
        case 'right':
          setIsEixoRightEyeDisabled(false);
          break;
        default:
          setIsEixoLeftEyeDisabled(false);
      }
      return;
    }

    switch (eye) {
      case 'right':
        setIsEixoRightEyeDisabled(true);
        break;
      default:
        setIsEixoLeftEyeDisabled(true);
    }
  };

  const clearFields = () => {
    formRef.current?.reset();
    formRef.current?.clearField('material_id');
    formRef.current?.clearField('manufacturer_id');
    formRef.current?.clearField('product_type_id');
    formRef.current?.clearField('product_id');
    formRef.current?.clearField('frame');
    formRef.current?.clearField('model');
    setTechnicalAssistanceActive(false);
    setMounting(false);
    setColoringActive(false);
    setAntiscratch(false);
    setAntireflectionActive(false);
    setSalesman({} as Salesman);
  };

  const handleConfirmData = async () => {
    if (isSystemBlocked) {
      toast.error(
        'Sistema bloqueado para novos cadastros a partir de 31/01/2026',
      );
      return;
    }

    formRef.current?.setFieldValue('salesman', salesman.name);
    if (!salesman.name) {
      toast.warn('Vendedor não informado');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (isOSDuplicated) {
      toast.warn('Número de OS informado já utilizado');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setIsDisabledToConfirmData(false);
    const data = formRef.current?.getData() ? formRef.current?.getData() : [];
    Object.assign(data, {
      is_add: Number(!isAdditionalDisabled),
      print_prisma: Number(!isPrismaEnabledToPrint),
    });

    formRef.current?.setErrors({});
    try {
      await schemaValidation.validate(data, {
        abortEarly: false,
      });

      setModalToConfirmDataIsOpen(true);
      setIsDisabledToConfirmData(true);
      toast.info('Por favor, confirme os dados antes de salvar', {
        autoClose: 10000,
      });
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current?.setErrors(errors);
        toast.warn('Verifique os campos novamente');
      }
    }
  };

  const handleCancelDataConfirmation = () => {
    setIsDisabledToConfirmData(false);
  };

  const handleSubmit: SubmitHandler<FormData> = async data => {
    if (isSystemBlocked) {
      toast.error(
        'Sistema bloqueado para novos cadastros a partir de 31/01/2026',
      );
      return;
    }

    if (isLoading) return;

    setIsLoading(true);
    formRef.current?.setErrors({});

    const customer_certified_name = certifiedClients.find(
      item => item.value === data.customer_certified_id,
    )?.label;

    // Cria um novo objeto ao invés de modificar data diretamente
    const payload = {
      ...data,
      customer_certified_name,
      right_base_quantity: Number(data.right_base_quantity),
      right_base: Number(data.right_base),
      left_base_quantity: Number(data.left_base_quantity),
      left_base: Number(data.left_base),
      is_add: Number(!isAdditionalDisabled),
      print_prisma: Number(isPrismaEnabledToPrint),
    };

    delete payload.product_type_id;
    delete payload.salesman_cpf;

    try {
      await schemaValidation.validate(payload, {
        abortEarly: false,
      });

      const response = await api.post('pre-os', payload);

      if (response.status === 201) {
        toast.success(
          'Pré-OS criada com sucesso. O PDF será gerado em seguida!',
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
        clearFields();
        setIsDisabledToConfirmData(false);
        const presOSCreated = await api.get<{ data: PreOSData }>(
          `pre-os/${data.os_number}`,
          {
            params: {
              register_by: user.login,
            },
          },
        );
        setPdfData(presOSCreated.data.data);
        setTimeout(() => {
          history.push(`${process.env.PUBLIC_URL}/pdf`);
        }, 3000);
      }
    } catch (error: any) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current?.setErrors(errors);
        toast.warn('Verifique os campos novamente');
        return;
      }

      if (error?.response?.status === 401) {
        history.replace(`${process.env.PUBLIC_URL}/`);
        return;
      }

      if (error?.response?.status === 400) {
        toast.error('Não foi possível criar a OS');
        return;
      }

      toast.error('Não foi possível processar sua solicitação');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSalesmanRegister: SubmitHandler<SalesmanFormData> = async data => {
    try {
      let response;
      const payload = {
        cpf: data.salesman_cpf.replaceAll(/[.-]+/g, ''),
        name: data.salesman_name,
      };

      if (salesman.id) {
        response = await api.put(`salesman/${salesman.id}`, payload);
      } else {
        response = await api.post('salesman', payload);
      }

      if (response.status === 201) {
        setSalesman(response.data);
        toast.success('Vendedor cadastrado com sucesso');
      }

      if (response.status === 200) {
        setSalesman(response.data);
        toast.success('Vendedor atualizado com sucesso');
      }
      setIsSalesmanRegisterModalOpen(false);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  const handleSearchSalesman = async () => {
    const cpf = formRef.current
      ?.getFieldValue('salesman_cpf')
      .replaceAll(/[.-]+/g, '');
    if (!cpf) return;

    try {
      const response = await api.get('salesman', {
        params: {
          cpf,
        },
      });
      if (response.status === 204) {
        toast.info('Vendedor não encontrado!');
        setSalesman({} as Salesman);
        setIsSalesmanRegisterModalOpen(true);
        setTimeout(() => {
          salesmanFormRef.current?.setFieldValue(
            'salesman_cpf',
            formRef.current?.getFieldValue('salesman_cpf'),
          );
        }, 1000);
      }

      if (response.data) {
        setSalesman(response.data);
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  const handleOpenModalToEditSalesman = () => {
    setIsSalesmanRegisterModalOpen(true);
    setTimeout(() => {
      salesmanFormRef.current?.setData({
        salesman_cpf: salesman.cpf,
        salesman_name: salesman.name,
      });
    }, 1000);
  };

  const handleSelectImageFromGrid = (modelIndex: number) => {
    setSelectedImageModel(modelIndex);
    const model = models.find(item => item.index === modelIndex);
    setModalImagesGridIsOpen(false);
    if (!model) return;
    formRef.current?.setFieldValue('model', model.label);
  };

  function handleSelectedEye() {
    const eye = formRef.current?.getFieldValue('eye');

    switch (eye) {
      case 0:
        setSelectedEye('left');
        formRef.current?.setFieldValue('esf_right_eye', 0);
        formRef.current?.setFieldValue('cil_right_eye', 0);
        formRef.current?.setFieldValue('eixo_right_eye', 0);
        formRef.current?.setFieldValue('add_right_eye', 0);
        formRef.current?.setFieldValue('dnp_right_eye', 0);
        break;
      case 1:
        setSelectedEye('right');
        formRef.current?.setFieldValue('esf_left_eye', 0);
        formRef.current?.setFieldValue('cil_left_eye', 0);
        formRef.current?.setFieldValue('eixo_left_eye', 0);
        formRef.current?.setFieldValue('add_left_eye', 0);
        formRef.current?.setFieldValue('dnp_left_eye', 0);
        break;
      default:
        setSelectedEye('both');
        break;
    }
  }

  async function handleDuplicatedOSNumber() {
    const os_number = formRef.current?.getFieldValue('os_number');

    if (!os_number) return;

    const { data } = await api.get(`/pre-os/${os_number}`, {
      params: {
        register_by: user.login,
      },
    });

    if (data.data) {
      setIsOSDuplicated(true);
      formRef.current?.setFieldError('os_number', 'Número de OS já utilizado');
    } else {
      setIsOSDuplicated(false);
      formRef.current?.setFieldError('os_number', '');
    }
  }

  const getButtonText = (defaultText: string) => {
    if (isSystemBlocked) {
      return 'Sistema Bloqueado';
    }
    if (isLoading) {
      return <Loading />;
    }
    return defaultText;
  };

  return (
    <>
      <Header />

      {isSystemBlocked && (
        <BlockedSystemBanner>
          🚫 SISTEMA BLOQUEADO - Não é possível cadastrar novas OSs a partir de
          31/01/2026. Consultas continuam disponíveis.
        </BlockedSystemBanner>
      )}

      <S.Form ref={formRef} onSubmit={handleSubmit} initialData={initialData}>
        <S.Card>
          <S.CardTitle>Dados da OS</S.CardTitle>
          <S.InputColumnGroupGrid cols={3}>
            <Input
              label="Nº OS *"
              name="os_number"
              type="text"
              disabled={isDisabledToConfirmData}
              onBlur={handleDuplicatedOSNumber}
            />
            <Input
              label="Cliente *"
              name="customer_name"
              type="text"
              disabled={isDisabledToConfirmData}
            />
            <InputMask
              label="Contato *"
              name="customer_contact"
              type="tel"
              mask="(99) 9 9999-9999"
              disabled={isDisabledToConfirmData}
            />
          </S.InputColumnGroupGrid>

          <S.InputColumnGroupGrid cols={3}>
            <Select
              label="Cliente certificado *"
              name="customer_certified_id"
              options={certifiedClients}
              isDisabled={isDisabledToConfirmData}
            />
            <Input
              label="Oftalmologista *"
              name="ophthalmologist"
              type="text"
              disabled={isDisabledToConfirmData}
            />
            <S.InputButtonGroup>
              <InputMask
                label="CPF do vendedor *"
                helperText={salesman.name || undefined}
                name="salesman_cpf"
                type="text"
                mask="999.999.999-99"
                disabled={isDisabledToConfirmData}
              />
              <S.SalesmanButtonsContainer>
                <Button
                  text={<SearchIcon width="20" height="20" />}
                  title="Consultar vendedor"
                  onClick={handleSearchSalesman}
                />
                <Button
                  text={<EditIcon width="20" height="20" />}
                  title="Editar vendedor"
                  disabled={!salesman.id}
                  onClick={handleOpenModalToEditSalesman}
                />
              </S.SalesmanButtonsContainer>
            </S.InputButtonGroup>
            <Input
              label="Vendedor"
              name="salesman"
              type="text"
              disabled={isDisabledToConfirmData}
              containerStyle={{ display: 'none' }}
            />
          </S.InputColumnGroupGrid>
          <Switch
            label="Assistência técnica"
            name="technical_assistance"
            containerStyle={{
              marginTop: '2rem',
              display: 'none',
            }}
            checked={technicalAssistanceActive}
            onChange={handleTechnicalAssistance}
            disabled={isDisabledToConfirmData}
          />
        </S.Card>
        <S.Card>
          <S.CardTitle>Especificações</S.CardTitle>
          <S.InputColumnGroupGrid cols={3}>
            <Select
              label="Tipo de produto *"
              name="product_type_id"
              options={productTypes}
              isDisabled={isDisabledToConfirmData}
              onBlur={toggleAdditionalFieldStatus}
            />
            <Select
              label="Fabricante *"
              name="manufacturer_id"
              options={manufacturers}
              isDisabled={isDisabledToConfirmData}
              onBlur={toggleOwnManufactureServices}
            />
            <Select
              label="Material *"
              name="material_id"
              options={materials}
              isDisabled={isDisabledToConfirmData}
            />
            <Select
              label="Produto *"
              name="product_id"
              options={products}
              onFocus={() => loadProducts()}
              isLoading={loadingProducts}
              loadingMessage={() => 'Carregando opções...'}
              isDisabled={isDisabledToConfirmData}
              onBlur={handleSelectedIdProduct}
            />
            <Select
              label="Olho *"
              name="eye"
              options={eyeOptions}
              menuPlacement="top"
              containerStyle={{ minWidth: '25rem' }}
              isDisabled={isDisabledToConfirmData}
              onBlur={handleSelectedEye}
            />
          </S.InputColumnGroupGrid>
        </S.Card>
        <S.Card>
          <S.CardTitle>Prescrição</S.CardTitle>
          <S.InputColumnGroupGrid cols={2}>
            <fieldset disabled={selectedEye === 'left'}>
              <legend>Olho Direito</legend>

              <S.InputRowGroup>
                <Input
                  label="Esf."
                  name="esf_right_eye"
                  type="number"
                  step="0.25"
                  disabled={isDisabledToConfirmData || selectedEye === 'left'}
                />
                <Input
                  label="Cil."
                  name="cil_right_eye"
                  type="number"
                  max="0"
                  min="-10.00"
                  step="0.25"
                  disabled={isDisabledToConfirmData || selectedEye === 'left'}
                  onBlur={() => handleEixoStatusField('right')}
                />
                <Input
                  label="Eixo"
                  name="eixo_right_eye"
                  type="number"
                  min={
                    isEixoRightEyeDisabled || selectedEye === 'left' ? '0' : '1'
                  }
                  max="180"
                  step="1"
                  readOnly={
                    isDisabledToConfirmData ||
                    isEixoRightEyeDisabled ||
                    selectedEye === 'left'
                  }
                />
                <Input
                  label="ADD"
                  name="add_right_eye"
                  type="number"
                  step="0.25"
                  max={
                    isAdditionalDisabled || selectedEye === 'left' ? '0' : '3.5'
                  }
                  min="0.50"
                  disabled={
                    isDisabledToConfirmData ||
                    isAdditionalDisabled ||
                    selectedEye === 'left'
                  }
                />
                <Input
                  label="DNP"
                  name="dnp_right_eye"
                  type="number"
                  step="0.1"
                  min="20"
                  max="40"
                  disabled={isDisabledToConfirmData || selectedEye === 'left'}
                />
                <Input
                  label="Altura"
                  name="height_right_eye"
                  type="number"
                  min="12"
                  max="35"
                  disabled={isDisabledToConfirmData || selectedEye === 'left'}
                />
              </S.InputRowGroup>
            </fieldset>

            <fieldset disabled={selectedEye === 'right'}>
              <legend>Olho Esquerdo</legend>

              <S.InputRowGroup>
                <Input
                  label="Esf."
                  name="esf_left_eye"
                  type="number"
                  step="0.25"
                  disabled={isDisabledToConfirmData || selectedEye === 'right'}
                />
                <Input
                  label="Cil."
                  name="cil_left_eye"
                  type="number"
                  max="0"
                  min="-10.00"
                  step="0.25"
                  disabled={isDisabledToConfirmData || selectedEye === 'right'}
                  onBlur={() => handleEixoStatusField('left')}
                />
                <Input
                  label="Eixo"
                  name="eixo_left_eye"
                  type="number"
                  min={
                    isEixoLeftEyeDisabled || selectedEye === 'right' ? '0' : '1'
                  }
                  max="180"
                  step="1"
                  readOnly={
                    isDisabledToConfirmData ||
                    isEixoLeftEyeDisabled ||
                    selectedEye === 'right'
                  }
                />
                <Input
                  label="ADD"
                  name="add_left_eye"
                  type="number"
                  max={
                    isAdditionalDisabled || selectedEye === 'right'
                      ? '0'
                      : '3.5'
                  }
                  min="0.50"
                  step="0.25"
                  disabled={
                    isDisabledToConfirmData ||
                    isAdditionalDisabled ||
                    selectedEye === 'right'
                  }
                />
                <Input
                  label="DNP"
                  name="dnp_left_eye"
                  type="number"
                  step="0.1"
                  min="20"
                  max="40"
                  disabled={isDisabledToConfirmData || selectedEye === 'right'}
                />
                <Input
                  label="Altura"
                  name="height_left_eye"
                  type="number"
                  min="12"
                  max="35"
                  disabled={isDisabledToConfirmData || selectedEye === 'right'}
                />
              </S.InputRowGroup>
            </fieldset>
          </S.InputColumnGroupGrid>
        </S.Card>
        <S.Card>
          <S.CardTitle>Medidas</S.CardTitle>
          <Switch
            label={
              isMeasuresDisabled
                ? 'Habilitar cadastro de medidas'
                : 'Desabilitar cadastro de medidas'
            }
            name="measures"
            checked={!isMeasuresDisabled}
            onChange={() => setIsMeasuresDisabled(!isMeasuresDisabled)}
            disabled={isDisabledToConfirmData}
          />
          <S.InputColumnGroupGrid cols={2}>
            <fieldset
              style={{ justifyContent: 'space-between' }}
              //  disabled={isMeasuresDisabled}
            >
              <legend>Modelo</legend>
              <S.InputGroupColumn>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <Select
                    label="Modelo"
                    name="model"
                    containerStyle={{
                      marginBottom: '1rem',
                      marginRight: '2rem',
                      width: '100%',
                    }}
                    options={models}
                    isDisabled
                  />
                  <S.ShowImagesGridButton
                    text="Ver Grid"
                    outlined
                    onClick={() => setModalImagesGridIsOpen(true)}
                    disabled={isDisabledToConfirmData} // isMeasuresDisabled || isDisabledToConfirmData
                  />
                </div>
                {selectedImageModel >= 0 && (
                  <S.ImagePreviewContainer>
                    <img
                      src={images[selectedImageModel]}
                      alt={`Modelo ${selectedImageModel}`}
                      width="50%"
                    />
                  </S.ImagePreviewContainer>
                )}
                <Select
                  label="Armação *"
                  name="frame"
                  containerStyle={{ marginBottom: '1rem' }}
                  options={frames}
                  isDisabled={isDisabledToConfirmData}
                />

                <Input
                  label="Referência da armação"
                  name="reference"
                  type="text"
                  containerStyle={{ marginBottom: '1rem' }}
                  disabled={isMeasuresDisabled || isDisabledToConfirmData}
                />
              </S.InputGroupColumn>
              <S.InputRowGroup>
                <Input
                  label="Horizontal"
                  name="horizontal"
                  type="number"
                  min="25"
                  max="75"
                  disabled={isMeasuresDisabled || isDisabledToConfirmData}
                />
                <Input
                  label="Vertical"
                  name="vertical"
                  type="number"
                  min="20"
                  max="55"
                  disabled={isMeasuresDisabled || isDisabledToConfirmData}
                />
                <Input
                  label="Ponte (PO)"
                  name="po"
                  type="number"
                  min="15"
                  max="25"
                  disabled={isMeasuresDisabled || isDisabledToConfirmData}
                />
                <Input
                  label="Diagonal"
                  name="diagonal"
                  type="number"
                  min="25"
                  max="80"
                  disabled={isMeasuresDisabled || isDisabledToConfirmData}
                />
              </S.InputRowGroup>
            </fieldset>

            <fieldset style={{ alignSelf: 'flex-start' }}>
              <legend>Serviços</legend>
              <Switch
                label="Montagem"
                name="mounting"
                containerStyle={{ marginBottom: '1rem' }}
                checked={mounting}
                onChange={setMounting}
                disabled={isDisabledToConfirmData}
              />
              <S.InputGroupBetween>
                <Switch
                  label="Coloração"
                  name="coloring"
                  containerStyle={{ marginBottom: '1rem' }}
                  checked={coloringActive}
                  onChange={handleColoringState}
                  disabled={isDisabledToConfirmData}
                />
                <Select
                  label="Tipo de coloração"
                  name="coloring_type"
                  options={servicesColoring}
                  containerStyle={{ minWidth: '25rem' }}
                  onFocus={() => loadServicesColoring()}
                  isLoading={loadingServicesColoring}
                  loadingMessage={() => 'Carregando opções...'}
                  isDisabled={!coloringActive || isDisabledToConfirmData}
                />
              </S.InputGroupBetween>
              <Switch
                label="Antirrisco"
                name="antiscratch"
                containerStyle={{ marginBottom: '1rem' }}
                checked={antiscratch}
                onChange={setAntiscratch}
                disabled={isDisabledToConfirmData}
              />
              <S.InputGroupBetween>
                <Switch
                  label="Antirreflexo"
                  name="antireflection"
                  containerStyle={{ marginBottom: '1rem' }}
                  checked={antireflectionActive}
                  onChange={handleAntirreflection}
                  disabled={isDisabledToConfirmData}
                />
                {hasOwnManufacture ? (
                  <Select
                    label="Serviços antirreflexo"
                    name="antireflection_type"
                    options={services}
                    containerStyle={{ minWidth: '25rem' }}
                    isDisabled={
                      !antireflectionActive || isDisabledToConfirmData
                    }
                  />
                ) : (
                  <Input
                    label="Tipo de Antirreflexo"
                    name="antireflection_type"
                    type="text"
                    disabled={!antireflectionActive || isDisabledToConfirmData}
                  />
                )}
              </S.InputGroupBetween>
              <Input
                label="Observações"
                name="observations"
                multiline
                disabled={isDisabledToConfirmData}
                title="Informações para assistência técnica"
                containerStyle={{ marginTop: 'auto' }}
              />
            </fieldset>
          </S.InputColumnGroupGrid>
        </S.Card>
        <S.Card>
          <S.CardTitle>Prisma</S.CardTitle>
          <Switch
            label={
              isPrismaEnabledToPrint ? 'Desabilitar prisma' : 'Habilitar prisma'
            }
            name="print_prisma"
            checked={isPrismaEnabledToPrint}
            onChange={() => setIsPrismaEnabledToPrint(!isPrismaEnabledToPrint)}
            disabled={isDisabledToConfirmData}
          />
          <S.PrismContainer>
            <fieldset disabled={!isPrismaEnabledToPrint}>
              <legend>Direito</legend>
              <Input
                label="Quantidade"
                name="right_base_quantity"
                min="0"
                max="10"
                type="number"
                disabled={isDisabledToConfirmData}
                containerStyle={{ minWidth: '10rem' }}
              />
              <Select
                label="Base"
                name="right_base"
                options={bases}
                menuPlacement="top"
                containerStyle={{ minWidth: '25rem' }}
                isDisabled={isDisabledToConfirmData}
              />
            </fieldset>

            <fieldset disabled={!isPrismaEnabledToPrint}>
              <legend>Esquerdo</legend>
              <Input
                label="Quantidade"
                name="left_base_quantity"
                type="number"
                min="0"
                max="10"
                disabled={isDisabledToConfirmData}
                containerStyle={{ minWidth: '10rem' }}
              />
              <Select
                label="Base"
                name="left_base"
                options={bases}
                menuPlacement="top"
                containerStyle={{ minWidth: '25rem' }}
                isDisabled={isDisabledToConfirmData}
              />
            </fieldset>
          </S.PrismContainer>
        </S.Card>

        {isDisabledToConfirmData ? (
          <S.ButtonsContainer>
            <Button
              text="Cancelar"
              type="button"
              onClick={handleCancelDataConfirmation}
              outlined
              containerStyle={{
                borderColor: 'red',
                color: 'red',
                marginRight: '1rem',
              }}
              disabled={isSystemBlocked}
            />
            <Button
              text={getButtonText('Salvar')}
              disabled={isLoading || isSystemBlocked}
              type="submit"
            />
          </S.ButtonsContainer>
        ) : (
          <S.ButtonsContainer>
            <Button
              text={getButtonText('Confirmar dados')}
              disabled={isLoading || isSystemBlocked}
              type="button"
              onClick={handleConfirmData}
            />
          </S.ButtonsContainer>
        )}
      </S.Form>
      <Modal
        modalIsOpen={isSalesmanRegisterModalOpen}
        setShowModal={() =>
          setIsSalesmanRegisterModalOpen(!isSalesmanRegisterModalOpen)
        }
        size="md"
      >
        <S.Form
          ref={salesmanFormRef}
          onSubmit={handleSalesmanRegister}
          style={{
            padding: '2rem 0 0',
          }}
        >
          <InputMask
            label="CPF"
            name="salesman_cpf"
            type="text"
            mask="999.999.999-99"
          />
          <Input label="Nome" name="salesman_name" type="text" />
          <Button
            text={salesman.id ? 'Atualizar' : 'Cadastrar'}
            type="submit"
            containerStyle={{ marginTop: 10, width: '100%' }}
          />
        </S.Form>
      </Modal>
      <Modal
        modalIsOpen={modalImagesGridIsOpen}
        setShowModal={() => setModalImagesGridIsOpen(!modalImagesGridIsOpen)}
        size="lg"
      >
        {warning && (
          <div
            style={{
              backgroundColor: 'red',
              color: 'white',
              padding: '10px',
              borderRadius: '4px',
              textAlign: 'center',
              marginBottom: '10px',
            }}
          >
            {warning}
          </div>
        )}
        <S.ModelImagesGrid>
          {images.map((image, index) => {
            const modelName = `Modelo ${index + 1}`;

            return (
              <S.ModelImageSelector
                key={modelName}
                onClick={() => handleSelectImageFromGrid(index)}
                isSelected={selectedImageModel === index}
              >
                <img src={image} alt={modelName} width="100%" />
              </S.ModelImageSelector>
            );
          })}
        </S.ModelImagesGrid>
      </Modal>
      <Modal
        modalIsOpen={modalToConfirmDataIsOpen}
        setShowModal={() =>
          setModalToConfirmDataIsOpen(!modalToConfirmDataIsOpen)
        }
        size="125rem"
      >
        <S.ConfirmDataContainer>
          <fieldset>
            <legend>Dados da OS</legend>
            <InputView
              label="Nº OS: "
              value={formRef.current?.getFieldValue('os_number')}
            />
            <InputView
              label="Cliente: "
              value={formRef.current?.getFieldValue('customer_name')}
            />
            <InputView
              label="Contato: "
              value={formRef.current?.getFieldValue('customer_contact')}
            />
            <InputView
              label="Cliente certificado: "
              value={
                certifiedClients.find(
                  c =>
                    c.value ===
                    formRef.current?.getFieldValue('customer_certified_id'),
                )?.label || ''
              }
            />
            <InputView
              label="Oftalmologista: "
              value={formRef.current?.getFieldValue('ophthalmologist')}
            />
            <InputView
              label="Vendedor: "
              value={formRef.current?.getFieldValue('salesman')}
            />
            <InputView
              label="Assistência técnica? "
              value={
                formRef.current?.getFieldValue('technical_assistance')
                  ? 'Sim'
                  : 'Não'
              }
            />
          </fieldset>

          <fieldset>
            <legend>Especificações</legend>
            <InputView
              label="Tipo de produto: "
              value={
                productTypes.find(
                  p =>
                    p.value ===
                    formRef.current?.getFieldValue('product_type_id'),
                )?.label || ''
              }
            />
            <InputView
              label="Fabricante: "
              value={
                manufacturers.find(
                  m =>
                    m?.value ===
                    formRef.current?.getFieldValue('manufacturer_id'),
                )?.label || ''
              }
            />
            <InputView
              label="Material: "
              value={
                materials.find(
                  m =>
                    m?.value === formRef.current?.getFieldValue('material_id'),
                )?.label || ''
              }
            />
            <InputView
              label="Produto: "
              value={
                products.find(
                  p => p.value === formRef.current?.getFieldValue('product_id'),
                )?.label || ''
              }
            />
            <InputView
              label="Olho: "
              value={
                eyeOptions.find(
                  e => e.value === formRef.current?.getFieldValue('eye'),
                )?.label || ''
              }
            />
          </fieldset>

          {selectedEye !== 'left' && (
            <fieldset>
              <legend>Prescrição (Olho direito)</legend>
              <InputView
                label="Esférico: "
                value={formRef.current?.getFieldValue('esf_right_eye')}
              />
              <InputView
                label="Cilíndrico: "
                value={formRef.current?.getFieldValue('cil_right_eye')}
              />
              <InputView
                label="Eixo: "
                value={formRef.current?.getFieldValue('eixo_right_eye')}
              />
              <InputView
                label="Adicional: "
                value={formRef.current?.getFieldValue('add_right_eye')}
              />
              <InputView
                label="DNP: "
                value={formRef.current?.getFieldValue('dnp_right_eye')}
              />
              <InputView
                label="Altura: "
                value={formRef.current?.getFieldValue('height_right_eye')}
              />
            </fieldset>
          )}

          {selectedEye !== 'right' && (
            <fieldset>
              <legend>Prescrição (Olho esquerdo)</legend>
              <InputView
                label="Esférico: "
                value={formRef.current?.getFieldValue('esf_left_eye')}
              />
              <InputView
                label="Cilíndrico: "
                value={formRef.current?.getFieldValue('cil_left_eye')}
              />
              <InputView
                label="Eixo: "
                value={formRef.current?.getFieldValue('eixo_left_eye')}
              />
              <InputView
                label="Adicional: "
                value={formRef.current?.getFieldValue('add_left_eye')}
              />
              <InputView
                label="DNP: "
                value={formRef.current?.getFieldValue('dnp_left_eye')}
              />
              <InputView
                label="Altura: "
                value={formRef.current?.getFieldValue('height_left_eye')}
              />
            </fieldset>
          )}

          <fieldset>
            <legend>Medidas</legend>
            <InputView
              label="Medidas? "
              value={formRef.current?.getFieldValue('measures') ? 'Sim' : 'Não'}
            />

            <InputView
              label="Modelo: "
              value={formRef.current?.getFieldValue('model')}
            />

            <InputView
              label="Armação: "
              value={formRef.current?.getFieldValue('frame')}
            />

            <InputView
              label="Referência da armação: "
              value={formRef.current?.getFieldValue('reference')}
            />

            <InputView
              label="Horizontal: "
              value={formRef.current?.getFieldValue('horizontal')}
            />

            <InputView
              label="Vertical: "
              value={formRef.current?.getFieldValue('vertical')}
            />

            <InputView
              label="Ponte (PO): "
              value={formRef.current?.getFieldValue('po')}
            />

            <InputView
              label="Diagonal: "
              value={formRef.current?.getFieldValue('diagonal')}
            />
          </fieldset>

          <fieldset>
            <legend>Serviços</legend>
            <InputView
              label="Montagem? "
              value={formRef.current?.getFieldValue('mounting') ? 'Sim' : 'Não'}
            />

            <InputView
              label="Coloração? "
              value={formRef.current?.getFieldValue('coloring') ? 'Sim' : 'Não'}
            />

            <InputView
              label="Tipo de Coloração: "
              value={formRef.current?.getFieldValue('coloring_type')}
            />

            <InputView
              label="Antirrisco? "
              value={
                formRef.current?.getFieldValue('antiscratch') ? 'Sim' : 'Não'
              }
            />

            <InputView
              label="Antirreflexo? "
              value={
                formRef.current?.getFieldValue('antireflection') ? 'Sim' : 'Não'
              }
            />

            <InputView
              label="Tipo de antirreflexo: "
              value={formRef.current?.getFieldValue('antireflection_type')}
            />

            <InputView
              label="Observações: "
              value={formRef.current?.getFieldValue('observations')}
            />
          </fieldset>

          {isPrismaEnabledToPrint ? (
            <fieldset>
              <legend>Prisma</legend>
              <InputView
                label="Prisma na impressão? "
                value={
                  formRef.current?.getFieldValue('print_prisma') ? 'Sim' : 'Não'
                }
              />

              <InputView
                label="Quantidade olho direito: "
                value={formRef.current?.getFieldValue('right_base_quantity')}
              />

              <InputView
                label="Base olho direito: "
                value={
                  bases.find(
                    b =>
                      b.value === formRef.current?.getFieldValue('right_base'),
                  )?.label || ''
                }
              />

              <InputView
                label="Quantidade olho esquerdo: "
                value={formRef.current?.getFieldValue('left_base_quantity')}
              />

              <InputView
                label="Base olho esquerdo: "
                value={
                  bases.find(
                    b =>
                      b.value === formRef.current?.getFieldValue('left_base'),
                  )?.label || ''
                }
              />
            </fieldset>
          ) : (
            <fieldset>
              <legend>Prisma</legend>
              <InputView label="Prisma na impressão? " value="Não" />
            </fieldset>
          )}
        </S.ConfirmDataContainer>
      </Modal>
      <Modal
        modalIsOpen={showDeprecationModal}
        setShowModal={() => setShowDeprecationModal(false)}
        size="md"
      >
        <DeprecationModalContent>
          <DeprecationWarning>
            <h2>⚠️ AVISO IMPORTANTE</h2>
            <p className="intro">
              Este sistema será <strong>bloqueado</strong> em:
            </p>
            <p className="date">31/01/2026</p>
            <p>
              A partir desta data, não será mais possível cadastrar novas OSs
              através deste site.
            </p>
            <p>
              As consultas e visualizações de OSs existentes continuarão
              funcionando normalmente.
            </p>
            <p>
              Por favor, entre em contato com o suporte para mais informações
              sobre o novo sistema.
            </p>
          </DeprecationWarning>
          <Button
            text="Entendi"
            type="button"
            onClick={() => setShowDeprecationModal(false)}
            containerStyle={{
              width: '100%',
              marginTop: '10px',
              backgroundColor: '#ff4444',
            }}
          />
        </DeprecationModalContent>
      </Modal>
    </>
  );
};

export default RegisterOS;
